import { FolderOpen } from 'lucide-react';
import { Button } from './Button';

/** Professional empty state (blueprint §7.1). Actions are permission-filtered by callers. */
export default function EmptyState({ icon: Icon = FolderOpen, title, body, action, secondaryAction, compact }) {
  return (
    <div className="empty" style={compact ? { padding: 'var(--sp-7) var(--sp-5)' } : undefined}>
      <div className="empty__icon" aria-hidden="true">
        <Icon size={26} strokeWidth={1.6} />
      </div>
      <div className="empty__title">{title}</div>
      {body && <p className="empty__body">{body}</p>}
      {(action || secondaryAction) && (
        <div className="row" style={{ gap: 'var(--sp-2)', marginTop: 'var(--sp-1)' }}>
          {action && (
            <Button variant="primary" icon={action.icon} onClick={action.onClick}>
              {action.label}
            </Button>
          )}
          {secondaryAction && (
            <Button variant="ghost" onClick={secondaryAction.onClick}>
              {secondaryAction.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
